import { TicketLocationDTO } from 'core/api';
import * as SalesStore from '../SalesStore';
import { Result } from 'core/infrastructure';
import { selectTicket, TicketSelection } from 'pos/modules/helpers/ticket-selection';
import { OrderingFacade } from 'pos/facades';

import { Command } from 'pos/common';
import createNewTicket from './createNewTicket';
import checkPendingCardTransactions from 'pos/modules/main/sale/checkPendingCardTransactions';

declare global {
	interface CommandType {
		selectTicketInLocation: (location: TicketLocationDTO) => Promise<Result>
	}
}

Command.register('selectTicketInLocation', 'NO_PRECONDITION', async (location: TicketLocationDTO): Promise<Result> => {
	const tickets = await OrderingFacade.getExistingTicketsIn(location.SaleCenterId, location.SaleLocationName);

	const result: Result<TicketSelection> = tickets.length === 0
		? Result.ok({ select: 'new' })
		: await selectTicket({ tickets }, 'show-create-new-command', 'show-ticket-commands');

	if (!result.ok)
		return Result.error();

	if (result.value.select === 'existing') {
		await SalesStore.loadTicketById(result.value.ticket.Id);

		const pendingResult = await checkPendingCardTransactions();
		if (!pendingResult.ok)
			return Result.error();

		return Result.ok();
	}

	// Si no es el existente me creo uno nuevo
	const createNewResult = await createNewTicket();
	if (!createNewResult.ok)
		return Result.error();

	return Result.ok();
});
